import {
    IServiceCasDeletedPositionsDto,
    IServiceCasDisbursementsDto,
    IServiceCasModifiedPositionsDto,
    IServiceCasNewPositionsDto,
    IServiceCasReorganizationDto,
    IServiceCorporateActionsGet,
    ISettingsDTCMessagesPutByIdParams,
    ListResult,
} from '@shared/api';
import { Api } from '../../Api';
import {
    ISettingsDTCMessagesCasDto,
    ISettingsDTCMessagesIcmDto,
    ISettingsDTCMessagesUtcDto,
    ISettingsDTCMessagesOwDto,
    ISettingsDTCMessagesCasPreviewDto,
    IServiceCasDetail,
    IServiceIcmDetail,
    IServiceUtcDetail,
    IServiceOwDetail,
} from './';
import { ISettingsDTCMessagesGetQuery } from './query';
import { ISettingsDTCMessagesGetByIdParams } from './params';

export class DTCMessages {
    private static _basePath = '';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${DTCMessages._basePath}`;
        return {
            async getCas(query?: ISettingsDTCMessagesGetQuery) {
                const path = '/corporate-actions';
                return await Api.get<ListResult<ISettingsDTCMessagesCasDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCasCount() {
                const path = '/corporate-actions/count';
                return await Api.get<number>({
                    path: `${basePath}${path}`,
                });
            },
            async getCasDetail({ id }: ISettingsDTCMessagesGetByIdParams) {
                const path = `/corporate-actions/${id}`;
                return await Api.get<IServiceCasDetail>({
                    path: `${basePath}${path}`,
                });
            },
            async putCasDividendApprove({ id }: ISettingsDTCMessagesPutByIdParams) {
                const path = `/corporate-actions/${id}/dividend/approve`;
                return await Api.put({
                    path: `${basePath}${path}`,
                });
            },
            async getCasPreview({ id }: ISettingsDTCMessagesGetByIdParams) {
                const path = `/corporate-actions/${id}/preview`;
                return await Api.get<ISettingsDTCMessagesCasPreviewDto>({
                    path: `${basePath}${path}`,
                });
            },
            async getCasResult({ id }: ISettingsDTCMessagesGetByIdParams) {
                const path = `/corporate-actions/${id}/result`;
                return await Api.get<ISettingsDTCMessagesCasPreviewDto>({
                    path: `${basePath}${path}`,
                });
            },
            async getCasModifiedPositions(
                { id, actionStatus }: IServiceCorporateActionsGet,
                query?: ISettingsDTCMessagesGetQuery,
            ) {
                const path = `/corporate-actions/${id}/${actionStatus}/modifiedPositions`;
                return await Api.get<ListResult<IServiceCasModifiedPositionsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCasNewPositions({ id }: ISettingsDTCMessagesGetByIdParams, query?: ISettingsDTCMessagesGetQuery) {
                const path = `/corporate-actions/${id}/preview/newPositions`;
                return await Api.get<ListResult<IServiceCasNewPositionsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCasDeletedPositions(
                { id }: ISettingsDTCMessagesGetByIdParams,
                query?: ISettingsDTCMessagesGetQuery,
            ) {
                const path = `/corporate-actions/${id}/preview/deletedPositions`;
                return await Api.get<ListResult<IServiceCasDeletedPositionsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCasDisbursements(
                { id, actionStatus }: IServiceCorporateActionsGet,
                query?: ISettingsDTCMessagesGetQuery,
            ) {
                const path = `/corporate-actions/${id}/${actionStatus}/distributions`;
                return await Api.get<ListResult<IServiceCasDisbursementsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getCasReorganization(
                { id, actionStatus }: IServiceCorporateActionsGet,
                query?: ISettingsDTCMessagesGetQuery,
            ) {
                const path = `/corporate-actions/${id}/${actionStatus}/reorganization`;
                return await Api.get<IServiceCasReorganizationDto>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getIcm(query?: ISettingsDTCMessagesGetQuery) {
                const path = '/messages/icm';
                return await Api.get<ListResult<ISettingsDTCMessagesIcmDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getIcmDetail({ id }: ISettingsDTCMessagesGetByIdParams) {
                const path = `/messages/icm/${id}`;
                return await Api.get<IServiceIcmDetail>({
                    path: `${basePath}${path}`,
                });
            },
            async getUtc(query?: ISettingsDTCMessagesGetQuery) {
                const path = '/messages/utc';
                return await Api.get<ListResult<ISettingsDTCMessagesUtcDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getUtcDetail({ id }: ISettingsDTCMessagesGetByIdParams) {
                const path = `/messages/utc/${id}`;
                return await Api.get<IServiceUtcDetail>({
                    path: `${basePath}${path}`,
                });
            },
            async getOw(query?: ISettingsDTCMessagesGetQuery) {
                const path = '/messages/ow';
                return await Api.get<ListResult<ISettingsDTCMessagesOwDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getOwDetail({ id }: ISettingsDTCMessagesGetByIdParams) {
                const path = `/messages/ow/${id}`;
                return await Api.get<IServiceOwDetail>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
